import globalStore from "@/store/global";
import BaseModal from "..";
import MarketingStore from '@/store/marketing';
import { SVGPureIcon } from "@/ui";

const renderConter = (data) => {
  // 营销云
  if (MarketingStore.isMarketingCloud) {
    return <div className="flex flex-col justify-start items-center pt-30px pb-26px rounded-20px w-320px h-180px" style={{
      background: 'url(https://p4.ssl.qhimg.com/t110b9a9301e99938c7b7d50908.png) no-repeat center/cover'
    }}>
     <h3 className="mt-18px leading-22px font-bold text-16px text-black text-opacity-90">今日次数已用完，请明天再来</h3>
     <div onClick={() => TrailExaustedModal?.close()} className="w-104px h-36px mt-38px rounded-12px bg-[#000000] text-14px flex justify-center items-center text-white hover:opacity-80 cursor-pointer">我知道了</div>
    </div>
  }
  // 会员能力
  if (data.isMember) {
    return <div className="flex flex-col justify-start items-center pt-30px pb-26px rounded-20px w-320px h-340px" style={{
      background: 'url(https://p4.ssl.qhimg.com/t110b9a9301e99938c7b7d50908.png) no-repeat center/cover'
    }}>
     <h3 className="font-bold text-16px text-black text-opacity-90">本次操作使用了会员权益</h3>
     <h3 className="font-bold text-16px text-black mb-14px text-opacity-90">Mac设备暂不支持开通会员</h3>
     <p className="mb-0 text-12px text-black opacity-50 mb-14px leading-18px">下载“纳米AI搜索”APP，解锁全部能力</p>
     <div className="p-7px rounded-16px mb-21px border-1px border-[#fff]" style={{
      boxShadow: '0px 2px 10px 0px #3F547A1A'
     }}>
      <img className="aspect-square w-180px rounded-16px" src="https://p5.ssl.qhimg.com/t110b9a9301e4eb68e01d739ffc.png" />
     </div>
     <div onClick={() => TrailExaustedModal?.close()} className="w-104px h-36px mt-38px rounded-12px bg-[#000000] text-14px flex justify-center items-center text-white hover:opacity-80 cursor-pointer">我知道了</div>
    </div>
  }
  // 纳米币不足
  if (data.nanoCostLack) {
    return <div className="flex flex-col justify-start items-center pt-30px pb-26px rounded-20px w-320px h-340px" style={{
      background: 'url(https://p4.ssl.qhimg.com/t110b9a9301e99938c7b7d50908.png) no-repeat center/cover'
    }}>
     <h3 className="font-bold text-16px text-black text-opacity-90">纳米余额不足</h3>
     <h3 className="font-bold text-16px text-black mb-14px text-opacity-90">Mac设备暂不支持充值</h3>
     <p className="mb-0 text-12px text-black opacity-50 mb-14px leading-18px">下载“纳米AI搜索”APP，解锁全部能力</p>
     <div className="p-7px rounded-16px mb-21px border-1px border-[#fff]" style={{
      boxShadow: '0px 2px 10px 0px #3F547A1A'
     }}>
      <img className="aspect-square w-180px rounded-16px" src="https://p5.ssl.qhimg.com/t110b9a9301e4eb68e01d739ffc.png" />
     </div>
     <div onClick={() => TrailExaustedModal?.close()} className="w-104px h-36px mt-38px rounded-12px bg-[#000000] text-14px flex justify-center items-center text-white hover:opacity-80 cursor-pointer">我知道了</div>
    </div>
  }

  return <div className="flex flex-col justify-start items-center pt-30px pb-26px rounded-20px w-320px h-340px" style={{
    background: 'url(https://p5.ssl.qhimg.com/t110b9a9301926f25022742f341.jpg) no-repeat center/cover'
  }}>
    <h3 className="mb-6px leading-22px text-16px text-black text-opacity-90">今日使用次数已用完，请明天再来</h3>
    <p className="mb-0 text-12px text-black opacity-50 mb-21px leading-18px">或手机下载“纳米AI搜索”app，畅想更多功能</p>
    <img className="aspect-square w-180px rounded-16px mb-21px" src="https://p5.ssl.qhimg.com/t110b9a9301e4eb68e01d739ffc.png" />
    <p className="!mb-0 text-12px leading-22px text-[#777]">立即扫码体验👆🏻</p>
  </div>
}

const TrailExaustedModal = {
  self: null,
  id: null,
  show(data) {
    return new Promise(resolve => {
      const handleOk = ok => {
        resolve(ok);
        this.close();
      };

      this.self = BaseModal.show({
        maskColor: 'rgba(0,0,0,0.3)',
        borderRadius: 20,
        content: renderConter(data),
        wrapClassName: 'nw-base-modal nw-base-modal-p-0 aigc-trial-exausted-modal',
        afterClose: () => {
          globalStore.delModal(this.id);
          this.id = null;
          data?.afterClose?.();
        },
      });
      this.id = globalStore.regModal(this);
    });
  },
  close() {
    if (this.self) {
      globalStore.delModal(this.id);
      this.id = null;
      this.self.destroy();
      this.self = null;
    }
  },
};

export default TrailExaustedModal;
